import { render } from "./footer.vue?vue&type=template&id=88827990"
const script = {}

import exportComponent from "/home/innovation/Documents/project/for small pos/BioLab/clientnew/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__